import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import { rootReducer } from './rootReducer';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Firebase User objects are not serializable — ignore them
        ignoredActions: ['auth/loginAction'],
        ignoredPaths: ['authState.usuario'],
      },
    }),
  devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export function useAppDispatch(): AppDispatch {
  return useDispatch<AppDispatch>();
}

export const useStateSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
